/*
 * Dependencies:
 *      - Material Table
 *      - Material Sort
 *      - Material Paginator
 *      - Table filter (own development)
 *      - Colum selector (own development)
 */
import {AfterViewInit, Component, Injectable, Injector, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {MatSort} from '@angular/material/sort';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MarterialTableListFilter} from './material-table-filter.class';
import { MATERIAL_LIST_IMPORTS } from './material-list.config';
import { ColumnSelectorComponent } from './column-selector/column-selector.component';

export {MatSort, MatPaginator}

@Injectable({
    providedIn: 'root'
})
export abstract class MaterialListAbstractComponent implements AfterViewInit, OnInit {
    paginator: MatPaginator | null = null;
    sort: MatSort | null = null;
    public abstract paginator_top: MatPaginator | undefined;
    public abstract paginator_bottom: MatPaginator | undefined;


    public abstract default_displayed_columns: string[];
    public abstract forbidden_columns: string[];
    public abstract displayed_column_filters: string[];

    protected abstract _data_source: any;   // Service to be listedS
    private _all_columns: string[] = [];

    private _displayed_columns: string[] = [];
    private _sess_names = {
        items_per_page: 'itemsPerPage'
    }
    public list_data: MatTableDataSource<any> = new MatTableDataSource<any>();
    public loading = false;

    // public filters: any = {};
    public page_size_options = [10, 25, 50, 100];

    private _defaults = {
//        filters: {},
        items_per_page: this.page_size_options[0]
    };

    // =========================================================================
    // -------------------------------------------------------------------------
    protected abstract readListData(): Observable<any[]>;
    protected abstract _afterReadData(list_rows: any[]): void;


    // =========================================================================
    // -------------------------------------------------------------------------
    constructor() {}

    // -------------------------------------------------------------------------
    ngOnInit(): void {
        this.all_columns = Object.keys(this._data_source.empty_record);
        //        this._displayed_columns = this.default_displayed_columns;
        this._refreshListData();

        //        this.list_data.sortingDataAccessor = (item, property): string | number => {
        //            switch (property) {
        //                case 'fecha_alta': return new Date(item[property]).toISOString();
        //                default: return item[property];
        //            }
        //        };

    }

    // -------------------------------------------------------------------------
    ngAfterViewInit() {

        this.list_data.sort = this.sort;
        if (this.paginator_top) {
            this.list_data.paginator = this.paginator_top;
        } else {
            this.list_data.paginator = this.paginator;
        }

        if (this.paginator_bottom) {
            this._initPaginatorBottom();
        }

    }

    // -------------------------------------------------------------------------
    get displayed_columns(): string[] {
        let stored_data: string[] | string | null = localStorage.getItem('dcolumns');
        if (!stored_data) {
            stored_data = this.default_displayed_columns;
        } else {
            stored_data = JSON.parse(stored_data);
        }
        this._updateFilterColumns(<string[]> stored_data);

        return <string[]> stored_data;
        //        return this._displayed_columns;
    }
    set displayed_columns(columns_list: string[]) {

        localStorage.setItem('dcolumns', JSON.stringify(columns_list));
        //        this._displayed_columns = columns_list;
    }

    // -------------------------------------------------------------------------
    // service source of data to list
    get serviceSource(): any {
        return this._data_source;
    }
    set serviceSource(service: any) {
        this._data_source = service;
    }

    // -------------------------------------------------------------------------
    get all_columns(): string[] {
        return this._all_columns;
    }
    set all_columns(columns_list: string[]) {
        this._all_columns = this.default_displayed_columns.filter(e => e !== 'command_cell');
        columns_list.forEach(e => {
            if (!this._all_columns.includes(e) && !this.forbidden_columns.includes(e)) {
                this._all_columns.push(e)
            }
        });
    }

    // -------------------------------------------------------------------------
    get items_per_page(): number {
        const sess_data: string | null = sessionStorage.getItem(this._sess_names.items_per_page);
        const saved_data = sess_data ? parseInt(sess_data) : this._defaults.items_per_page;

        return saved_data;

    }
    set items_per_page(data: number) {

        sessionStorage.setItem(this._sess_names.items_per_page, data.toString());

    }

    // =========================================================================
    // =========================================================================
    // -------------------------------------------------------------------------
    protected _setListaData(new_rows: any[]): void {

        // Sort by order_screen
        new_rows.sort((r1: any, r2: any) => r1.order_screen - r2.order_screen);

        this.list_data.data = [];
        // deeep copy of objects in array
        for (let inx = 0; inx < new_rows.length; inx++) {
            this.list_data.data.push(Object.assign({}, new_rows[inx]));
        }

        this._afterReadData(new_rows);
        this.loading = false;

    }

    // =========================================================================
    // -------------------------------------------------------------------------
    protected _refreshListData(): any {

        this.loading = true;
        this.readListData().subscribe(
            (readed_data: any[]) => {
                this._setListaData(readed_data);
            },
            () => {
                this._setListaData([]);
            }
        );

    }

    // ---------------------------------------------------------------------------
    // sync data between top and bottom paginator
    //     is there is not top => do nothing
    protected _initPaginatorBottom(): any {

        if (!this.paginator_top) {
            return
        }

        this.paginator_top.page.pipe(
            tap(() => {
                this.paginator_bottom!.length = this.paginator_top!.length;
                this.paginator_bottom!.pageIndex = this.paginator_top!.pageIndex;
                this.paginator_bottom!.pageSize = this.paginator_top!.pageSize;
            })
        ).subscribe();

        this.paginator_bottom!.page.pipe(
            tap(() => {
                if (this.paginator_top!.pageIndex === this.paginator_bottom!.pageIndex - 1) {
                    this.paginator_top!.nextPage();
                } else if (this.paginator_top!.pageIndex === this.paginator_bottom!.pageIndex + 1) {
                    this.paginator_top!.previousPage();
                } else if (this.paginator_bottom!.pageIndex === 0) {
                    this.paginator_top!.firstPage();
                } else if (this.paginator_bottom!.pageIndex === this.paginator_bottom!.getNumberOfPages() - 1) {
                    this.paginator_top!.lastPage();
                // } else if (this.paginator_bottom!.length === this.paginator_bottom!.getNumberOfPages() - 1) {
                //     this.paginator_top!.lastPage();
                }
            })
        ).subscribe();
        
        setTimeout(() => 
            this.paginator_top!.page.emit()
        , 250
        );

    }


    // -------------------------------------------------------------------------
    private _updateFilterColumns(columns: string[]): void {

        this.displayed_column_filters = columns.map(e => 'f' + e);

    }

    // =========================================================================
    // -------------------------------------------------------------------------
    public onColumnsChange(new_columns: string[] | undefined) {

        if (!new_columns) {
            new_columns = this.default_displayed_columns;
        } else {
            new_columns.push('command_cell');
        }

        this.displayed_columns = new_columns;
        //        this.displayed_column_filters = this.displayed_columns.map(e => 'f' + e);
        this._updateFilterColumns(this.displayed_columns);
    }

    // -------------------------------------------------------------------------
    public pageSendToTop(data: PageEvent): void {
        console.log('PageEvent: ', data);
    }

}
